export const TRANSACTION_TYPE = {
  QR_CODE: "qrcode",
  PAYMENT: "payment",
};
